<div class="coverage__item__wrapper">
	<div class="flex gap-2">
		<div class="coverage__item__wrapper__icon">
			<img src="check_icon.svg" alt="check" />
		</div>
		<div class="coverage__item__wrapper__text">
			<div>
				{{ item()!.name }}
			</div>
			@if (item()!.insuredCapital) {
				<div class="font-semibold text-sm">
					{{
						(item()!.insuredCapital) ?? 0
							| currencyFormat: 'ARS'
					}}
				</div>
			}
		</div>
	</div>
</div>
